export default {
  URLS: {
    KIOSK:'/kiosk/',
    TIMECARD: 'timecards/',
    DAILY_TIMECARD: 'daily-timecards/',
    AGGREGATE: 'aggregrate/'
  },
};

